import type { AspidaClient, BasicHeaders } from 'aspida';
import type { Methods as Methods_by08hd } from '.';

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? 'http://localhost:18081' : baseURL).replace(/\/$/, '');
  const PATH0 = '/v1/auth/token';
  const POST = 'POST';

  return {
    /**
     * リフレッシュトークンを渡して、アクセストークンを取得します。<br/>
     * <br/>
     * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
     *
     * <ul>
     * <li>400：必須項目が無いなどのリクエスト不正。</li>
     * <li>401：対象のリフレッシュトークンが未登録の場合。</li>
     * </ul>
     * @returns 処理成功
     */
    post: (option: { body: Methods_by08hd['post']['reqBody'], config?: T | undefined }) =>
      fetch<Methods_by08hd['post']['resBody'], BasicHeaders, Methods_by08hd['post']['status']>(prefix, PATH0, POST, option).json(),
    /**
     * リフレッシュトークンを渡して、アクセストークンを取得します。<br/>
     * <br/>
     * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
     *
     * <ul>
     * <li>400：必須項目が無いなどのリクエスト不正。</li>
     * <li>401：対象のリフレッシュトークンが未登録の場合。</li>
     * </ul>
     * @returns 処理成功
     */
    $post: (option: { body: Methods_by08hd['post']['reqBody'], config?: T | undefined }) =>
      fetch<Methods_by08hd['post']['resBody'], BasicHeaders, Methods_by08hd['post']['status']>(prefix, PATH0, POST, option).json().then(r => r.body),
    $path: () => `${prefix}${PATH0}`,
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
